"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../../..");
var __2 = require("../../../..");
var enums_1 = require("../../../../types/enums");
var Select_1 = __importDefault(require("../../../Select"));
var WarmHomeAdviceInput = function () {
    var _a, _b, _c, _d;
    var trans = __2.useSemantics().trans;
    var _e = formik_1.useFormikContext(), errors = _e.errors, values = _e.values;
    var adviceGiven = values.project.warm_home.warm_home_advice;
    return (react_1.default.createElement(__1.FormControl, { errors: (_b = (_a = errors.project) === null || _a === void 0 ? void 0 : _a.warm_home) === null || _b === void 0 ? void 0 : _b.warm_home_advice, label: trans('project:slhh::labels.warm-home-advice'), showOther: adviceGiven && adviceGiven.indexOf(enums_1.BooleanOther.OTHER) > -1, other: react_1.default.createElement(__1.FormControl, { errors: (_d = (_c = errors.project) === null || _c === void 0 ? void 0 : _c.warm_home) === null || _d === void 0 ? void 0 : _d.warm_home_advice_other, label: trans('project:slhh::labels.warm-home-advice-other') },
            react_1.default.createElement(__1.TextArea, { fast: true, name: "project.warm_home.warm_home_advice_other", maxLength: 5000 })) },
        react_1.default.createElement(Select_1.default, { options: {
                provide_whd_advice: trans('project:slhh::enum.warm-home-advice.provide_whd_advice'),
                eligible_with_current_supplier: trans('project:slhh::enum.warm-home-advice.eligible_with_current_supplier'),
                eligible_with_different_supplier: trans('project:slhh::enum.warm-home-advice.eligible_with_different_supplier'),
                eligible_with_any_supplier: trans('project:slhh::enum.warm-home-advice.eligible_with_any_supplier'),
                already_receiving: trans('project:slhh::enum.warm-home-advice.already_receiving'),
                none: trans('project:slhh::enum.warm-home-advice.none'),
                other: trans('project:slhh::enum.warm-home-advice.other'),
            }, name: "project.warm_home.warm_home_advice" })));
};
exports.default = WarmHomeAdviceInput;
//# sourceMappingURL=WarmHomeAdviceInput.js.map